
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';

/*Optical Module*/
import { OpticalModuleRoutingModule } from './optical-module.routing';
import { OpticalModuleComponent } from './optical-module.component';
import { OpticalHeaderComponent } from './optical-header/optical-header.component';
import { OpticalSidePanelComponent } from './optical-side-panel/optical-side-panel.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        OpticalModuleComponent,
        OpticalHeaderComponent,
        OpticalSidePanelComponent
        // OpdVisitsComponent,
        // LoaderComponent,
        // AppointmentListComponent
    ],
    imports: [
        CommonModule,
        OpticalModuleRoutingModule,
        SharedModule

    ],
    exports: [
        MatDatepickerModule
    ],
    providers: [
        {provide: MatDialogRef, useValue: {}}
     ]
    
   })
   export class OpticalModule{
   
   }